import axios from "axios";
import { authStore } from "@/store/auth";
import router from "@/router";
import { getCurrentInstance } from "vue";
import { getProductSlugFromUserAgent } from "@/utils/browserUtil";
const ACCOUNT_LOCK_MESSAGE = "このユーザーアカウントはロックされています。";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL_BASE
});

axiosInstance.interceptors.request.use(config => {
  const token = authStore.token;
  if (token) {
    config.headers.common["Authorization"] = `JWT ${token}`;
  }

  const username = authStore.user?.username;
  if (username) {
    config.headers.common["X-User-Username"] = username;
  }

  const productSlug =
    authStore.currentProductSlug || getProductSlugFromUserAgent();
  config.headers.common["X-Product-Slug"] = productSlug;

  return config;
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.data?.detail === ACCOUNT_LOCK_MESSAGE) {
      await authStore.logout();
      await router.push({ name: "Welcome" });
      alert("このユーザーアカウントはロックされています。");
      const instance = getCurrentInstance();
      if (instance) {
        instance.proxy!.$root!.$loading.hide();
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const axiosClient = axiosInstance;
